<style lang="less" scoped>
@import "../assets/css/common.less";
i {
  font-style: normal;
}
.searchData {
  margin-top: 40px;
  padding-top: 55px;
}
.links {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: inline-block;
}
.links img {
  width: 20px;
  margin-right: 3px;
}
</style>
<template>
  <div>
    <!-- <Header ref="header"></Header> -->
    <div class="content">
      <div class="searchData">
        <van-list
          v-if="datas.length > 0"
          class="van-list"
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="getList"
        >
          <van-cell class="datas" v-for="(item, index) in datas" :key="index">
            <h4 class="title" v-if="item.titleZh" style="display: flex">
              <a @click="handle_paper(item)">{{ item.titleZh }}</a>
            </h4>

            <p class="parse">
              <span
                >{{ $t("people.people26") }}: <i>{{ item.keywordsZh }}</i></span
              >
            </p>

            <p class="parse">
              <span
                >{{ $t("search.search1") }}: <i>{{ item.year }}</i></span
              >
            </p>

            <p class="parse identify">
              <a
                class="date links"
                :href="'/' + $checkPrefix(item.identifier)"
                target="_blank"
                ><img
                  class="link"
                  style="margin-right: 6px"
                  src="@/assets/images/nav.png"
                /><span>CSTR:</span
                >{{ item.identifier.replace("CSTR:", "") }}</a
              >
            </p>

            <div class="iview">
              <span title="访问量"
                ><svg
                  t="1623035280900"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5756"
                  width="200"
                  height="200"
                >
                  <path
                    d="M512 256c205.65 0 372.364 167.625 372.364 256S717.65 768 512 768c-205.65 0-372.364-167.625-372.364-256S306.35 256 512 256z m0 74.473c-77.128 0-154.72 29.776-217.286 78.942-26.923 21.157-49.105 44.588-63.933 66.735-6.42 9.59-11.116 18.444-13.972 25.952-1.14 2.996-1.912 5.589-2.353 7.695l-0.13 0.657c-0.15 0.802-0.208 1.311-0.217 1.504V512c0 0.187 0.083 0.94 0.347 2.203 0.44 2.106 1.214 4.7 2.353 7.695 2.856 7.508 7.551 16.362 13.972 25.952 14.828 22.147 37.01 45.578 63.933 66.735C357.28 663.75 434.872 693.527 512 693.527c77.128 0 154.72-29.776 217.286-78.942 26.923-21.157 49.105-44.588 63.933-66.735 6.42-9.59 11.116-18.444 13.972-25.952 1.14-2.996 1.912-5.589 2.353-7.695l0.09-0.45c0.193-0.993 0.257-1.59 0.257-1.753l-0.01-0.164c-0.028-0.323-0.123-1.012-0.337-2.039-0.44-2.106-1.214-4.7-2.353-7.695-2.856-7.508-7.551-16.362-13.972-25.952-14.828-22.147-37.01-45.578-63.933-66.735C666.72 360.25 589.128 330.473 512 330.473z"
                    fill="#999999"
                    p-id="5757"
                  ></path>
                  <path
                    d="M512 372.364c77.119 0 139.636 62.517 139.636 139.636S589.12 651.636 512 651.636 372.364 589.12 372.364 512 434.88 372.364 512 372.364z m0 74.472c-35.989 0-65.164 29.175-65.164 65.164 0 35.989 29.175 65.164 65.164 65.164 35.989 0 65.164-29.175 65.164-65.164 0-35.989-29.175-65.164-65.164-65.164z"
                    fill="#979797"
                    p-id="5758"
                  ></path></svg
                >{{ item.viewCount }}</span
              >
              <span
                ><img
                  class="resolve"
                  title="解析量"
                  src="../assets/images/resolve.png"
                />{{ item.resolveCount }}</span
              >
            </div>
          </van-cell>
        </van-list>

        <noData v-else></noData>
      </div>
      <back-top></back-top>
    </div>
  </div>
</template>
<script>
import { Loadmore } from "mint-ui";
import { Indicator } from "mint-ui";
import backTop from "./backTop.vue";

import noData from "./nodata.vue";
// import Header from "@/components/comHeader.vue";
export default {
  components: {
    [Loadmore.name]: Loadmore,
    backTop,
    // Header,
    noData,
    [Indicator.name]: Indicator,
  },

  data() {
    return {
      pageNumber: 1,
      topStatus: "",
      pageSize: 10,
      allLoaded: false,
      loading: false,
      finished: false,
      total: 0,
      datas: [],
      container: "data",

      showEU: true,
      showNSF: false,
      prefix: "",
      url: "",
      lang: "",
      // title: this.$t("keywords.keywords14"),
    };
  },
  mounted() {
    this.lang = this.$cookie.get("lang");
    // this.$refs.header.title = this.title;
    Indicator.open({
      text: "loading...",
      spinnerType: "fading-circle",
    });
  },

  methods: {
    getDissList() {
      var parameter = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        container: this.container,
      };
      this.$api.getDissList(parameter).then((res) => {
        if (res.data.code == 200) {
          Indicator.close();
          const results = res.data.data.content;
          this.datas = res.data.data.content;
          this.pageNumber++;
          this.loading = false;

          if (results.length === 0) {
            this.finished = true;
          }
        } else {
          Indicator.close();
        }
      });
    },
    search() {
      this.datas = [];
      Indicator.open({
        text: "loading...",
        spinnerType: "fading-circle",
      });
      this.pageNumber = 1;
      this.getList();
    },
    cancel() {},
    handle_paper(item) {
      if (this.lang != "en") {
        this.$router.push({
          name: "dissDetail",
          query: {
            cstr: this.$checkPrefix(item.identifier),
          },
        });
      } else {
        this.$router.push({
          name: "EndissDetail",
          query: {
            cstr: this.$checkPrefix(item.identifier),
          },
        });
      }
      // var links = this.$router.resolve({
      //   name: "search-paperDetail",
      //   query: {
      //     cstr: item.cstr,
      //   },
      // });
      // window.open(links.href, "_blank");
    },
  },
};
</script>